<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_MAIN_MAIN_MANUFACTURERS_ABROAD'
        )
      }"
    >
      <textarea
        v-on:keyup="
          $parent.$parent.removeError(
            'PROJECTS',
            'LOGIC',
            'UF_MAIN_MAIN_MANUFACTURERS_ABROAD'
          )
        "
        class="i-main-style t-dop-style i-wid-50"
        style="height:72px;"
        v-model="$parent.project.UF_MAIN_MAIN_MANUFACTURERS_ABROAD"
        :disabled="$parent.$parent.projectDisabled"
        placeholder=""
      ></textarea>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_MAIN_MAIN_MANUFACTURERS_ABROAD"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Uf_main_main_manufacturers_abroad"
};
</script>

<style scoped></style>
